const handleOrientationReload = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        window.addEventListener("orientationchange", () => {
            setTimeout(() => {
                if (window.innerWidth >= 1025) {
                    location.reload();
                }
            }, 300);
        });
    };

    init();
};

try {
    handleOrientationReload();
} catch (error) {
    console.error("handleOrientationReload", error);
}
